import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=8625ae02&"
import script from "./NotFound.vue?vue&type=script&lang=coffee&"
export * from "./NotFound.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports